import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem("authToken");
    const countryCode = localStorage.getItem("countryCode") || "cz";
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Country-Code": countryCode,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          "Content-Type": "application/json",
          "Country-Code": countryCode,
        },
      });
    }
    return next.handle(request);
  }
}
